import * as PIXI from 'pixi.js';

import { CARD_HEIGHT, CARD_WIDTH, getProxiedCardImageUrl } from '../utils';

export const PLACEHOLDER_CARD_FILE = 'anim-editor-card.png';

let texture = null;

export const placeholderCardTexture = () => {
    if (texture) return texture;

    const canvas = document.createElement('canvas');
    canvas.width = CARD_WIDTH;
    canvas.height = CARD_HEIGHT;
    const context = canvas.getContext('2d');
    context.fillStyle = '#1a2744';
    context.fillRect(0, 0, CARD_WIDTH, CARD_HEIGHT);
    context.strokeStyle = '#e0c36a';
    context.lineWidth = 8;
    context.strokeRect(6, 6, CARD_WIDTH - 12, CARD_HEIGHT - 12);
    context.fillStyle = '#f4ead0';
    context.font = 'bold 28px sans-serif';
    context.textAlign = 'center';
    context.fillText('CARD', CARD_WIDTH / 2, CARD_HEIGHT / 2);

    texture = PIXI.Texture.from(canvas);
    const alias = getProxiedCardImageUrl(PLACEHOLDER_CARD_FILE);
    if (PIXI.Assets.cache.has(alias)) {
        PIXI.Assets.cache.remove(alias);
    }
    PIXI.Assets.cache.set(alias, texture);
    return texture;
};
